import { NextSeo } from "next-seo";
import { Navbar } from "~/components/Navbar/component";
import { Routes } from "~/routes";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { Footer } from "~/components/Footer";
import { PageHeader } from "~/components/PageHeader";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { BreadcrumbSEO } from "~/modules/app/seo/BreadcrumbSEO";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { SOCIAL_OG_IMAGE_URL } from "~/consts";
import { AssetScreenerListingPage } from "~/modules/asset_screener/pages/listing/AssetScreenerListingPage";
import {
    AssetScreenerSEO,
    getAssetScreenerPageDescription,
} from "~/modules/app/seo/AssetScreenerSEO";
import {
    AssetScreenerPageProps,
    getAssetScreenerStaticProps,
} from "~/modules/asset_screener/pages/listing/getAssetScreenerPageProps";

// // // //

export const getStaticProps = getAssetScreenerStaticProps;

// // // //

export default function AssetScreenerV2Page(props: AssetScreenerPageProps) {
    const { assets } = props;

    return (
        <PageTrack route={Routes.assetScreener}>
            <NextSeo
                title="Asset Screener"
                canonical={addBaseUrl(Routes.assetScreener)}
                description={getAssetScreenerPageDescription()}
                openGraph={{
                    type: "website",
                    url: addBaseUrl(Routes.assetScreener),
                    title: "Asset Screener",
                    site_name: "RWA.xyz",
                    description: getAssetScreenerPageDescription(),
                    images: [
                        {
                            url: SOCIAL_OG_IMAGE_URL,
                            width: 4000,
                            height: 2300,
                            alt: "rwa.xyz",
                        },
                    ],
                }}
            />
            <AssetScreenerSEO />
            <BreadcrumbSEO
                items={[
                    {
                        name: "Asset Screener",
                        href: Routes.assetScreener,
                    },
                ]}
            />

            <UserFetcher>
                {({ user }) => (
                    <Navbar route={Routes.assetScreener} user={user} />
                )}
            </UserFetcher>

            <SidebarLayout pathname={Routes.assetScreener}>
                <PageWrapper>
                    <div className="mx-auto w-full max-w-6xl">
                        <PageHeader
                            title="Asset Screener"
                            subtitle="Screen tokenized assets by yield, redemption terms, asset class, platform, and network. Returns are denominated in USD."
                        />
                    </div>

                    <AssetScreenerListingPage assets={assets} />

                    <Footer />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
